<template>
  <popup-modal ref="popup">
    <h4 class="mb-4 comments">
      <b>{{ message }}</b>
    </h4>
    <b-container class="popup" fluid>
      <b-row>
        <b-col>
          <b-form-textarea class="textarea" placeholder="Enter your comment" rows="5" v-model="comment">
          </b-form-textarea>
        </b-col>
      </b-row>
    </b-container>
    <div class="btns mt-3">
      <b-button variant="primary" @click="onSave">Confirm</b-button>
      <b-button variant="dark" class="ml-2" @click="_cancel">Cancel</b-button>
    </div>
  </popup-modal>
</template>

<script>
import PopupModal from "@/components/popups/popup-modal.vue";

export default {
  name: "CancelDuplicateDlg",
  components: { PopupModal },
  data() {
    return {
      message: "",
      comment: "",

      updatedData: {
        isOk: false,
        comment: ""
      }
    };
  },
  methods: {
    onSave() {
      this.updatedData = {
        isOk: true,
        comment: this.comment
      };

      this.resolvePromise(this.updatedData);
      this.resetState();

      this.$refs.popup.close();
    },
    show(opts = {}) {
      this.message = opts.message;

      this.$refs.popup.open();
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    _cancel() {
      this.resetState();
      this.$refs.popup.close();
      this.resolvePromise(false);
    },
    resetState() {
      this.comment = "";
    }
  }
};
</script>

<style scoped lang="scss">
.textarea {
  resize: none;
}

.btns {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: auto;
}

.popup {
  @include media-breakpoint-tablet() {
    width: 30rem;
  }
}
</style>
